<div class="isdialog-taskbar" *ngIf="all.length" [ngClass]="'isdialog-taskbar--' + taskbarPosition" role="toolbar" aria-label="Gestão de janelas">
  <button class="isdialog-taskbar__manager-trigger" type="button" (click)="toggleManager($event)"
          title="Gestor de janelas (Ctrl+Alt+Shift+J)" [attr.aria-expanded]="managerOpen">
    <i class="fa-solid fa-layer-group" aria-hidden="true"></i>
    <span>{{all.length}}</span>
  </button>

  <div class="isdialog-taskbar__item" *ngFor="let item of visible; trackBy: trackById"
       [attr.data-isdialog-window-id]="item.id" tabindex="0" role="button"
       [attr.aria-label]="'Restaurar ' + item.title" (click)="restore(item, $event)"
       (keydown.enter)="restore(item, $event)" (keydown.space)="restore(item, $event)">
    <i class="fa-solid isdialog-taskbar__icon" [ngClass]="item.icon ? 'fa-' + item.icon : 'fa-window-maximize'" aria-hidden="true"></i>
    <span class="isdialog-taskbar__title" [title]="item.title">{{item.title || 'Janela'}}</span>
    <button type="button" class="isdialog-taskbar__close" [attr.aria-label]="'Fechar ' + item.title"
            (click)="close(item, $event)" title="Fechar janela">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </div>

  <button type="button" *ngIf="overflow.length" class="isdialog-taskbar__more"
          [matMenuTriggerFor]="overflowMenu" [attr.aria-label]="overflow.length + ' janelas adicionais'">
    +{{overflow.length}} <i class="fa-solid fa-chevron-up" aria-hidden="true"></i>
  </button>

  <section *ngIf="managerOpen" class="isdialog-manager" role="dialog" aria-label="Gestor de janelas"
           (click)="$event.stopPropagation()" (keydown.escape)="managerOpen = false">
    <header class="isdialog-manager__header">
      <div><strong>Janelas</strong><span>{{all.length}} abertas</span></div>
      <button type="button" class="isdialog-manager__icon-button" (click)="managerOpen = false" aria-label="Fechar gestor">×</button>
    </header>
    <div class="isdialog-manager__search">
      <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
      <input type="search" [(ngModel)]="query" placeholder="Pesquisar por título..." aria-label="Pesquisar janelas" />
    </div>
    <div class="isdialog-manager__filters" role="group" aria-label="Filtrar janelas">
      <button type="button" [class.selected]="filter === 'all'" (click)="filter = 'all'">Todas</button>
      <button type="button" [class.selected]="filter === 'open'" (click)="filter = 'open'">Abertas</button>
      <button type="button" [class.selected]="filter === 'min'" (click)="filter = 'min'">Minimizadas</button>
    </div>
    <div class="isdialog-manager__list">
      <div *ngFor="let item of results; trackBy: trackById" class="isdialog-manager__row"
           [class.isdialog-manager__row--active]="item.active">
        <button type="button" class="isdialog-manager__window" (click)="restore(item)">
          <i class="fa-solid" [ngClass]="item.icon ? 'fa-' + item.icon : 'fa-window'" aria-hidden="true"></i>
          <span class="isdialog-manager__details"><strong [title]="item.title">{{item.title || 'Janela'}}</strong>
            <small>{{item.inPictureInPicture ? 'Picture-in-Picture' : item.minimized ? 'Minimizada' : item.active ? 'Ativa' : 'Aberta'}}<span *ngIf="item.pinned"> · Fixada</span></small></span>
        </button>
        <button type="button" class="isdialog-manager__icon-button" title="Fixar/desafixar" [attr.aria-label]="'Fixar ' + item.title" (click)="handler.togglePin(item.id)">
          <i class="fa-solid fa-thumbtack" [class.isdialog-manager__pinned]="item.pinned"></i>
        </button>
        <button type="button" class="isdialog-manager__icon-button" title="Fechar" [attr.aria-label]="'Fechar ' + item.title" (click)="close(item, $event)">×</button>
      </div>
      <p *ngIf="!results.length" class="isdialog-manager__empty">Nenhuma janela encontrada.</p>
    </div>
    <div class="isdialog-manager__actions">
      <button type="button" (click)="handler.minimizeAllDialogs()">Minimizar todas</button>
      <button type="button" (click)="handler.restoreAllDialogs()">Restaurar todas</button>
    </div>
    <div class="isdialog-manager__layouts">
      <span>Organizar janelas</span>
      <div class="isdialog-manager__layout-buttons">
        <button type="button" (click)="arrange('cascade')" title="Cascata">Cascata</button>
        <button type="button" (click)="arrange('side-by-side')" title="Lado a lado">2 col.</button>
        <button type="button" (click)="arrange('grid')" title="Grelha">Grelha</button>
        <button type="button" (click)="arrange('columns')" title="Três colunas">3 col.</button>
      </div>
      <button type="button" class="isdialog-manager__undo" (click)="handler.undoArrange()">Desfazer última organização</button>
    </div>
    <div class="isdialog-manager__settings">
      <span>Preferências</span>
      <label class="isdialog-manager__preference"><input type="checkbox" [ngModel]="handler.preferences.animations" (ngModelChange)="handler.setPreference('animations', $event)" /> Animações de janelas</label>
      <label class="isdialog-manager__preference"><input type="checkbox" [ngModel]="handler.preferences.dragSnap" (ngModelChange)="handler.setPreference('dragSnap', $event)" /> Snapping por arrastamento</label>
      <span>Posição da Taskbar</span>
      <button type="button" [class.selected]="taskbarPosition === 'left'" (click)="setPosition('left')">Esquerda</button>
      <button type="button" [class.selected]="taskbarPosition === 'center'" (click)="setPosition('center')">Centro</button>
      <button type="button" [class.selected]="taskbarPosition === 'right'" (click)="setPosition('right')">Direita</button>
    </div>
  </section>
</div>

<mat-menu #overflowMenu="matMenu" class="isdialog-taskbar-menu">
  <div *ngFor="let item of overflow; trackBy: trackById" class="isdialog-taskbar__menu-item">
    <button type="button" mat-menu-item (click)="restore(item, $event)" [title]="item.title">
      <i class="fa-solid fa-window-restore me-2" aria-hidden="true"></i><span>{{item.title || 'Janela'}}</span>
    </button>
    <button type="button" class="isdialog-taskbar__menu-close" (click)="close(item, $event)" [attr.aria-label]="'Fechar ' + item.title" title="Fechar">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
</mat-menu>
